module.exports = __webpack_public_path__ + "img/balance_bg.d907ba2d.png";